import PropTypes from 'prop-types'

import { STRING } from 'resources'

import ScreenContainer from 'components/ScreenContainer'

import { Banner, RedeemRequirementsText, TextContainer, LearnMoreButton } from './styles'

const RedemptionRequirementsBanner = ({ handleOpenModal }) => (
  <Banner>
    <ScreenContainer removePaddingTop removePaddingBottom>
      <TextContainer>
        <RedeemRequirementsText>
          {STRING.wallet.redemptions.redemptionBanner.bannerDescription}
          <LearnMoreButton onClick={handleOpenModal}>
            {STRING.wallet.redemptions.redemptionBanner.bannerLinkText}
          </LearnMoreButton>
        </RedeemRequirementsText>
      </TextContainer>
    </ScreenContainer>
  </Banner>
)

RedemptionRequirementsBanner.propTypes = {
  handleOpenModal: PropTypes.func.isRequired,
}

export default RedemptionRequirementsBanner
